export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS';
// Dynamic Imports
export const SET_COMPONENT_IN_STORE = 'SET_COMPONENT_IN_STORE';
